<template>
    <v-card v-if="article"
            :to="{ name: 'news-details', params: { newsId: article.id }}"
            class="fill-height pa-2"
            flat
            tile>
        <v-row no-gutters>
            <v-col cols="auto" v-if="article.image_preview || article.image_header">
                <v-avatar size="115"
                          tile>
                    <v-img
                        :src="article.image_preview ? article.image_preview.source : article.image_header.source">
                    </v-img>
                </v-avatar>
            </v-col>

            <v-col class="pt-0 pb-2 pl-3 pr-2">
                <div class="subtitle-1 secondary--text text-uppercase">{{ article.date_of_news | date }}</div>
                <h3 class="subtitle-1 font-weight-bold mb-3">
                    {{ article.headline }}
                </h3>
                <p class="body-1 mb-0">{{ article.teasertext }}</p>
            </v-col>

            <v-col cols="auto" style="width: 50px">
                <v-img v-for="(brand, index) in article.related_brands"
                       :key="index"
                       class="mb-2"
                       max-width="50px"
                       max-height="18px"
                       contains
                       :src="brand.image"></v-img>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        name: 'news-card',
        props: {
            article: {
                required: true,
                type: Object,
            },
        },
    }
</script>
